export enum Sections {
	Welcome = "welcome",
	About = "about",
	Experience = "experience",
	Skills = "skills",
	Stats = "stats",
	Social = "social",
}

export const PageUrl = window.location.origin;
